/**
 * Link previews send every linked URL to a third party (api.microlink.io). A
 * link in a bot message can be anything the course author put there, including
 * a private or signed URL, so previews are only requested for hosts on
 * REACT_APP_PREVIEW_ALLOWED_HOSTS. No list means no previews.
 */
export function parsePreviewAllowedHosts(raw = process.env.REACT_APP_PREVIEW_ALLOWED_HOSTS) {
  return new Set(
    String(raw || '')
      .split(',')
      .map((host) => host.trim().toLowerCase())
      .filter(Boolean)
  );
}

export function isPreviewAllowed(url, allowed = parsePreviewAllowedHosts()) {
  if (!allowed || allowed.size === 0) return false;
  let parsed;
  try {
    parsed = new URL(url);
  } catch {
    return false;
  }
  if (parsed.protocol !== 'https:') return false;
  const host = parsed.hostname.toLowerCase();
  for (const pattern of allowed) {
    if (pattern.startsWith('*.')) {
      if (host.endsWith(pattern.slice(1))) return true;
    } else if (host === pattern) {
      return true;
    }
  }
  return false;
}
